/**
 * Job announcement list JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class JobsList
 */
class JobsList {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.jobFilters     = $( '.js-job-filter' );
        this.toggleAll      = $( '#js-toggle-all' );
        this.jobResults     = $( '.js-job-result' );
        this.filterButton   = $( '#js-filter-announcements-button' );
        this.subMenuToggles = $( '.js-submenu-toggle' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // This selects all filters.
        this.toggleAll.on( 'click', () =>  {
            this.jobFilters.each( ( index, jobFilter ) => {
                $( jobFilter ).removeClass( 'selected' ).addClass( 'selected' );
            });
        });

        // This controls the selected-state of each individual filter.
        this.jobFilters.each( ( index, jobFilter ) => {

            const $jobFilter = $( jobFilter );

            $jobFilter.on( 'click', () =>  {
                $jobFilter.toggleClass( 'selected' );
            });
        });

        // This toggles the opened state of each sub level filter section.
        this.subMenuToggles.each( ( index, subMenuToggle ) => {

            const $subMenuToggle = $( subMenuToggle );

            $subMenuToggle.on( 'click', () =>  {

                $subMenuToggle.toggleClass( 'toggled' );

                const childClass = '#js-sublevel-' + $subMenuToggle.attr( 'data-code' );
                $( childClass ).toggleClass( 'js-hidden' );
            });
        });

        // This filters the results based on selected filter occupation codes.
        this.filterButton.on( 'click', this.filterResults );
    }

    /**
     * This goes through all filters and shows results according to
     * selected filters' codes.
     */
    filterResults() {

        const $selectedFilters = $( '.job-filter.selected' );
        let resultAmount       = 0;

        // Here we go through each result and see if its
        // code begins with any of the codes in the selected
        // filters. If there's a match, we set a flag to show the result.
        $( '.js-job-result' ).each( ( index, jobResult ) => {

            const $jobResult = $( jobResult );
            const jobCode    = $jobResult.attr( 'data-code' );
            let showResult   = false;

            $selectedFilters.each( ( index, selectedFilter ) => {

                const filterCode = $( selectedFilter ).attr( 'data-code' );
                if ( jobCode.startsWith( filterCode ) ) {
                    showResult = true;
                }
            });

            // First hide all by default and show only the ones that
            // have the 'show' flag set.
            $jobResult.addClass( 'js-hidden' );
            if ( showResult ) {
                $jobResult.removeClass( 'js-hidden' );

                // Update the amount of shown items
                // with each found item.
                resultAmount++;
            }
        });

        // This puts the updated amount in place
        // and shows the container.
        $( '#js-result-amount' ).text( resultAmount );
        $( '#js-result-amount-container' ).removeClass( 'js-hidden' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = JobsList;



// WEBPACK FOOTER //
// ./assets/scripts/jobslist.js